import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';

export default function TenantDomainFunctionBasicInfoComponent ({domainDetails,domain,parentDomain,handleInnerFormChange, selectedDomain}: any) {
    const libraryData = useSelector(selectListItems)
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

<InputContainer
                  label="Feature Name"
                  labelField="Name"
                  list={domain}
                  onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                       'FeatureId'
                       );
                  }}
                  optionName ="Choose Feature Name"
                  type="select"
                  value={selectedDomain?.FeatureId}
                  valueField="Id"
              />
           <InputContainer

            label="Function Name"
            name="FunctionName"
            onValueChange={(event: any) => {
                handleInnerFormChange(
                    event.target.value,
                   'FunctionName'
                   );
            }}
            type="text"
            value={selectedDomain?.FunctionName}
            />
        
     
        {/* <InputContainer
                  label="Parent Function"
                  labelField="FunctionName"
                  list={parentDomain}
                  onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                       'ParentFunctionId'
                       );
                  }}
                  optionName ="Choose Parent Function"
                  type="select"
                  value={selectedDomain?.ParentFunctionId}
                  valueField="Id"
              /> */}
<InputContainer

label="Custom Function Name"
name="CustomFunctionName"
onValueChange={(event: any) => {
    handleInnerFormChange(
        event.target.value,
       'CustomFunctionName'
       );
}}
type="text"
value={selectedDomain?.CustomFunctionName}
/>
<InputContainer
                 label="Domain Name"
                 labelField="Name"
                 list={domainDetails}
                 onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'DomainId',
  
                  )
                 }}
                 optionName="Choose Domain"
                 type="select"
                 value={selectedDomain?.DomainId}
                 valueField="Id"
             />
   <InputContainer
                 label="Function Type"
                 labelField="Text"
                 list={libraryData?.result?.DomainType}
                 onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                       'FunctionTypeId'
                       );
                 }}
                 optionName ="Choose Function Type"
                 type="select"
                 value={selectedDomain?.FunctionTypeId}
                 valueField="Value"
             />
              <InputContainer
                 label="Function Level"
                 labelField="Text"
                 list={libraryData?.result?.DomainLevel}
                 onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                       'FunctionLevelId'
                       );
                 }}
                 optionName ="Choose Function Level"
                 type="select"
                 value={selectedDomain?.FunctionLevelId}
                 valueField="Value"
             />

                    <InputContainer

                    label="Display Order"
                    name="DisplayOrder"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                        'DisplayOrder'
                        );
                    }}
                    type="number"
                    value={selectedDomain?.DisplayOrder}
                    />
             <InputContainer

                label="Icon"
                name="Icon"
                onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event.target.value,
                       'Icon'
                       );
                }}
                type="text"
                value={selectedDomain?.Icon}
                />
                <InputContainer

                    label="Color"
                    name="Color"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                           'Color'
                           );
                    }}
                    type="text"
                    value={selectedDomain?.Color}
                    />
                                     <InputContainer

label="Code"
name="Code"
onValueChange={(event: any) => {
    handleInnerFormChange(
        event.target.value,
       'Code'
       );
}}
type="text"
value={selectedDomain?.Code}
/>
                    <InputContainer

                        label="Route"
                        name="Route"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                               'Route'
                               );
                        }}
                        type="text"
                        value={selectedDomain?.Route}
                        />

<InputContainer

label="Active"
name="IsActive"
onValueChange={(event: any) => {
    handleInnerFormChange(
        event,
       'IsActive'
       );
}}
type="checkbox"
value={selectedDomain?.IsActive}
/>

<InputContainer

    label="Tag Allowed"
    name="IsTagAllowed"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'IsTagAllowed'
           );
    }}
    type="checkbox"
    value={selectedDomain?.IsTagAllowed}
/>

<InputContainer

    label="TenantEntityAttributeAllowed"
    name="IsTenantEntityAttributeAllowed"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'IsTenantEntityAttributeAllowed'
           );
    }}
    type="checkbox"
    value={selectedDomain?.IsTenantEntityAttributeAllowed}
/>
<InputContainer

label="Folder"
name="HasFolder"
onValueChange={(event: any) => {
    handleInnerFormChange(
        event,
       'HasFolder'
       );
}}
type="checkbox"
value={selectedDomain?.HasFolder}
/>

<InputContainer

    label="Deleted"
    name="IsDeleted"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'IsDeleted'
           );
    }}
    type="checkbox"
    value={selectedDomain?.IsDeleted}
/>
<InputContainer

    label="Report"
    name="HasReport"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'HasReport'
           );
    }}
    type="checkbox"
    value={selectedDomain?.HasReport}
/>
<InputContainer

    label="Analytics"
    name="HasAnalytics"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'HasAnalytics'
           );
    }}
    type="checkbox"
    value={selectedDomain?.HasAnalytics}
/>
                                <InputContainer

                                    label="ValidForPortal"
                                    name="IsValidForPortal"
                                    onValueChange={(event: any) => {
                                        handleInnerFormChange(
                                            event,
                                           'IsValidForPortal'
                                           );
                                    }}
                                    type="checkbox"
                                    value={selectedDomain?.IsValidForPortal}
                                    />
                                    <InputContainer

label="ValidForPOS"
name="IsValidForPOS"
onValueChange={(event: any) => {
    handleInnerFormChange(
        event,
       'IsValidForPOS'
       );
}}
type="checkbox"
value={selectedDomain?.IsValidForPOS}
/>
<InputContainer

    label="ValidForPSP"
    name="IsValidForPSP"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'IsValidForPSP'
           );
    }}
    type="checkbox"
    value={selectedDomain?.IsValidForPSP}
/>

<InputContainer

    label="VAlid For MCP"
    name="IsValidForMCP"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'IsValidForMCP'
           );
    }}
    type="checkbox"
    value={selectedDomain?.IsValidForMCP}
/>
<InputContainer

    label="VAlid For Mobile APP"
    name="IsValidForMobileApp"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'IsValidForMobileApp'
           );
    }}
    type="checkbox"
    value={selectedDomain?.IsValidForMobileApp}
/>

<InputContainer

    label="Template Mapping Enabled"
    name="IsTemplateMappingEnabled"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'IsTemplateMappingEnabled'
           );
    }}
    type="checkbox"
    value={selectedDomain?.IsTemplateMappingEnabled}
/>

<InputContainer

    label="Grid View Enabled"
    name="IsGridViewEnabled"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'IsGridViewEnabled'
           );
    }}
    type="checkbox"
    value={selectedDomain?.IsGridViewEnabled}
/>
<div className='col-span-full'>
<InputContainer

     label="Description"
     name="Description"
     onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'Description'
           );
     }}
     type="rte"
     value={selectedDomain?.Description}
 /></div>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}